






import Vue from 'vue';

interface BreadcrumbItem {
  disabled: boolean;
  exact: boolean;
  href: string;
  link: boolean;
  text: string | number;
  to: string | object;
}

export default Vue.extend({
  name: 'CoreBreadcrumbs',

  computed: {
    allBreadcrumbs() {
      const pathArray = this.$route.path.split('/');
      const breadcrumbs: Partial<BreadcrumbItem>[] = [];

      pathArray.forEach((path, index) => {
        const text = this.$route.matched[index].meta?.breadcrumb || path;

        const prevPath = breadcrumbs[index - 1]?.to || '';
        const to = `${prevPath}/${path}`.replace(/\/+/, '/');

        if (text) {
          breadcrumbs.push({
            to,
            text
          });
        }
      });

      return breadcrumbs;
    }
  }
});
